/**
 * Production configuration settings
 */

export const PRODUCTION_CONFIG = {
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  
  // URLs
  siteUrl: 'https://weirdobeach.com',
  apiUrl: 'https://brmhxrfcrxzrtsxmgkep.supabase.co',
  
  // Feature flags
  features: {
    analytics: true,
    errorTracking: true,
    pushNotifications: true,
    offlineMode: true,
    serviceWorker: true,
  },
  
  // Performance settings
  performance: {
    enableCaching: true,
    cacheTimeouts: {
      shortTerm: 5 * 60 * 1000, // 5 minutes
      mediumTerm: 30 * 60 * 1000, // 30 minutes  
      longTerm: 24 * 60 * 60 * 1000, // 24 hours
    },
    maxRetries: 3,
    retryDelay: 1000,
  },
  
  // Security settings
  security: {
    enableCSP: true,
    enableSRI: true,
    enableHTTPS: true,
    sessionTimeout: 24 * 60 * 60 * 1000, // 24 hours
  },
  
  // Monitoring settings
  monitoring: {
    enablePerformanceTracking: true,
    enableErrorBoundaries: true,
    enableConsoleLogging: !import.meta.env.PROD,
    sampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  },
  
  // PWA settings
  pwa: {
    cacheName: 'weirdobeach-v18', // Unified cache version
    updateInterval: 60 * 60 * 1000, // 1 hour
    maxCacheAge: 7 * 24 * 60 * 60 * 1000, // 7 days
  },
} as const;

export type ProductionConfig = typeof PRODUCTION_CONFIG;